import React from 'react'
import { Form } from '@pinchenterprisesnpm/friday-ui'
import { Col } from 'styled-bootstrap-grid'
import GenericTooltip from '../../GenericTooltip'
import { ColumnType, OffsetType } from '../utils'
import { Label, TooltipWrapper, LabelTooltipWrapper } from './style'

const { Switch } = Form

type FormSwitchProps = {
  label?: string | React.ReactNode
  name: string
  value: boolean
  handleChange: (field: string, value: any) => void
  leftLabel?: string
  type?: string | undefined
  rightLabel?: string
  tooltipMessage?: string
  fieldColumns?: ColumnType
  labelColumns?: ColumnType
  fieldOffset?: OffsetType
  isDisabled?: boolean
  isLabelBold?: boolean
  switchTooltipMessage?: string
  labelTooltipMessage?: string
  verticalCenterLabel?: boolean
  labelHasPadding?: boolean
}

const FormSwitch = ({
  label = '',
  name,
  value,
  handleChange,
  leftLabel,
  rightLabel,
  fieldColumns = 9,
  labelColumns = 2,
  fieldOffset = 0,
  isDisabled,
  isLabelBold = true,
  switchTooltipMessage,
  labelTooltipMessage,
  verticalCenterLabel = true,
  labelHasPadding,
}: FormSwitchProps) => {
  return (
    <>
      {label && (
        <Col lg={labelColumns}>
          <LabelTooltipWrapper isVerticallyCentered={verticalCenterLabel}>
            <Label isLabelBold={isLabelBold} hasPadding={labelHasPadding}>
              {label} {labelTooltipMessage && <GenericTooltip message={labelTooltipMessage} />}
            </Label>
          </LabelTooltipWrapper>
        </Col>
      )}
      <Col lg={fieldColumns} md={fieldColumns} offset={fieldOffset} mdOffset={fieldOffset}>
        <Switch
          value={value}
          onChange={(values) => {
            handleChange(name, values)
          }}
          isDisabled={isDisabled}
          leftLabel={leftLabel}
          rightLabel={rightLabel}
        />
        {switchTooltipMessage && (
          <TooltipWrapper>
            <GenericTooltip message={switchTooltipMessage} />
          </TooltipWrapper>
        )}
      </Col>
    </>
  )
}

export default FormSwitch
